// 大屏登录态：与 PC 端共用 /system/auth/login 颁发的令牌，按租户隔离数据
const ACCESS_TOKEN_KEY = "BS_ACCESS_TOKEN";
const REFRESH_TOKEN_KEY = "BS_REFRESH_TOKEN";
const TENANT_ID_KEY = "BS_TENANT_ID";
// 令牌来源：PC 菜单交接的令牌与 PC 端共用，退出大屏时不能在服务端注销
const FROM_PC_KEY = "BS_FROM_PC";

export const isTokenFromPc = () => localStorage.getItem(FROM_PC_KEY) === "1";

export const getAccessToken = () => localStorage.getItem(ACCESS_TOKEN_KEY);

export const getRefreshToken = () => localStorage.getItem(REFRESH_TOKEN_KEY);

export const getTenantId = () => localStorage.getItem(TENANT_ID_KEY);

export const setToken = ({ accessToken, refreshToken }) => {
  localStorage.setItem(ACCESS_TOKEN_KEY, accessToken);
  if (refreshToken) {
    localStorage.setItem(REFRESH_TOKEN_KEY, refreshToken);
  }
};

export const setTenantId = (tenantId) => {
  if (tenantId !== undefined && tenantId !== null && tenantId !== "") {
    localStorage.setItem(TENANT_ID_KEY, String(tenantId));
  }
};

export const clearAuth = () => {
  localStorage.removeItem(ACCESS_TOKEN_KEY);
  localStorage.removeItem(REFRESH_TOKEN_KEY);
  localStorage.removeItem(TENANT_ID_KEY);
  localStorage.removeItem(FROM_PC_KEY);
};

/**
 * 从 PC 端菜单跳转时，令牌经 URL hash 传入（#token=...&refreshToken=...&tenantId=...）。
 * hash 不会发往服务器；读取后立即从地址栏抹除，避免留在历史记录中。
 */
export const consumeHashToken = () => {
  const hash = window.location.hash;
  if (!hash || hash.indexOf("token=") === -1) {
    return;
  }
  const params = new URLSearchParams(hash.substring(1));
  const accessToken = params.get("token");
  if (accessToken) {
    clearAuth();
    setToken({ accessToken, refreshToken: params.get("refreshToken") });
    setTenantId(params.get("tenantId"));
    localStorage.setItem(FROM_PC_KEY, "1");
  }
  window.history.replaceState(
    null,
    "",
    window.location.pathname + window.location.search
  );
};
